import { API } from '@thuas/pd-schemas';
import api from 'helpers/api';
import { callGet, Retrieving } from 'helpers/apiTypes';
import { prepareForBackend, toArrayOfIdObject } from 'helpers/objects';

export type IFolder = API['Folder']['read'];
export type IFolderCreate = Omit<
  API['Folder']['create'],
  'subFolders' | 'files' | 'links'
>;

type IFolderUpdate = API['Folder']['update'] & {
  filesOverwrite?: { id: number }[];
  linksOverwrite?: { id: number }[];
};

export interface ILibrary {
  rootFolder: IFolder | null;
  allFolders: IFolder[];
}

function prepareForUpdate(folder: IFolder): IFolderUpdate {
  const updated = prepareForBackend(folder, [
    'id',
    'files',
    'subFolders',
  ]) as IFolderUpdate;
  updated.filesOverwrite = toArrayOfIdObject(folder.files);
  return updated;
}

export const fetchFolders = async () => {
  try {
    const query = {
      '*': true,
      parentFolder: {
        id: true,
      },
      subFolders: {
        id: true,
      },
      files: {
        '*': true,
        folder: {
          '*': true,
        },
      },
    } as const satisfies Retrieving<'Folder'>;
    const response = await callGet('Folder', query);
    return response.response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};

export const postFolder = async (data: IFolderCreate) => {
  try {
    return await api.post('Folder', data);
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};

export const patchFolder = async (data: IFolder) => {
  try {
    return await api.patch('Folder/' + data.id, prepareForUpdate(data));
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};

export async function deleteFolder(folderId?: number) {
  try {
    if (!folderId) return;
    return await api.delete(`Folder/${folderId}`);
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
}
